



var fullSiteRoot = 'https://hufworldwide.eu';

// environment

hufConfig.fullSiteRoot = fullSiteRoot;

hufConfig.shopBaseURL = fullSiteRoot;


// general

hufConfig.colorOptionName = 'Color';

hufConfig.siteRegion = 'eu';
hufConfig.currencyISO = 'EUR';


// add to cart messages

hufConfig.qtyLowMessage = 'Only a few left, order quick!';
hufConfig.qtyLastMessage = 'Only one left, order quick!';
hufConfig.qtyLimitMessage = 'You have reached the quantity limit for this product.';


// geo

hufConfig.shopifyGeoDataURL = fullSiteRoot + '/browsing_context_suggestions.json';
hufConfig.ipStackGeoDataURL = 'https://api.ipstack.com/check?access_key=' + '58adea01e643cfe009402227675e55ad_xxx';


// algolia

hufConfig.algoliaAppId = 'XYHY9WJOFP';
hufConfig.algoliaAPIKey = '4c5bbc76d33a743d55f14c78f6803e8c';

hufConfig.algoliaProductsIndex = 'shopify_products';
hufConfig.algoliaProductsSortingIndexes = [
  ['Featured', hufConfig.algoliaProductsIndex],
  ['Price: High to Low', 'shopify_products_high-to-low'],
  ['Price: Low to High', 'shopify_products_low-to-high']
];
//hufConfig.algoliaCollectionsIndex = 'huf_shopify_collections';
//hufConfig.algoliaPagesIndex = 'huf_shopify_pages';
//hufConfig.algoliaArticlesIndex = 'huf_shopify_articles';

hufConfig.noSearchResultsMessage = 'Sorry, no matches found.';

hufConfig.separateAllListingProductsByColor = false;
hufConfig.separateListingProductsByColorTag = 'Separate Colors';


// klaviyo

hufConfig.klaviyoSiteId = 'XJCehV';
hufConfig.klaviyoListId = 'TeRucB';


// payments

hufConfig.paymentOptionService = 'sezzle';


// sold out notify

hufConfig.notifyEmailEnabled = false;
//hufConfig.notifyPhoneEnabled = true;
//hufConfig.notifyDefaultMethod = 'phone';


// cart

hufConfig.cartAjaxEnabled = true;

hufConfig.fakeCartAjax = false;
hufConfig.cartDataBaseURL = fullSiteRoot;

hufConfig.miniCartCheckoutURL = fullSiteRoot + '/checkout';
hufConfig.miniCartViewCartURL = fullSiteRoot + '/cart';


// urls

hufConfig.collectionURL = fullSiteRoot + '/collections/{collection_slug}';
hufConfig.collectionProductURL = fullSiteRoot + '/collections/{collection_slug}/products/{product_slug}';
hufConfig.productURL = fullSiteRoot + '/products/{product_slug}';
hufConfig.pageURL = fullSiteRoot + '/pages/{page_slug}';
hufConfig.articleURL = fullSiteRoot + '/blogs/{blog_slug}/{article_slug}';

// store locator map

hufConfig.mapStyles = ( // generate using https://snazzymaps.com/editor
  [
      {
          "featureType": "administrative",
          "elementType": "labels.text.fill",
          "stylers": [
              {
                  "color": "#444444"
              }
          ]
      },
      {
          "featureType": "landscape",
          "elementType": "all",
          "stylers": [
              {
                  "color": "#f2f2f2"
              }
          ]
      },
      {
          "featureType": "poi",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "road",
          "elementType": "all",
          "stylers": [
              {
                  "saturation": -100
              },
              {
                  "lightness": 45
              }
          ]
      },
      {
          "featureType": "road.highway",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "simplified"
              }
          ]
      },
      {
          "featureType": "road.arterial",
          "elementType": "labels.icon",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "transit",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "water",
          "elementType": "all",
          "stylers": [
              {
                  "color": "#e1e1e1"
              },
              {
                  "visibility": "on"
              }
          ]
      }
  ]
);